"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = void 0;
exports.ErrorCodes = {
    NO_SUPPORTED_FORMAT_FOUND: '500',
    MEDIA_LOAD_FAILED: '510',
    GENERAL_FAILURE: 'A00',
    GENERAL_FATAL_ERROR: 'A05',
    DEVICE_UNSUPPORTED: 'C00',
    NETWORK_FAILURE: 'D00',
    NETWORK_SLOW: 'D01',
    PLAYER_FAILURE: 'F00',
    PLAYER_UNKNOWN_CHANNEL: 'F05',
    PLAYER_WIFI_REQUIRED: 'F08',
    PLAYER_SOURCE_UNAVAILABLE: 'F09',
    DOWNLOAD_FAILURE: 'G00',
    DOWNLOAD_UNFINISHED: 'G01',
    DOWNLOAD_NO_SPACE: 'G02',
    DOWNLOAD_EXPIRED: 'G03',
};
//# sourceMappingURL=ErrorCodes.js.map